<template>
  <div>
    <div
      ref="maindiv"
      :class="$style['mds-date-picker']"
      :aria-expanded="showDatePicker ? 'true' : 'false'"
      :aria-controls="containerId"
      aria-haspopup="true"
      v-click-outside:hideDatePicker="{ inputId, calendarId, month }"
    >
      <mds-label
        :on-dark="onDark"
        :size="size"
        :required="required"
        :required-text="requiredText"
        :text="label"
        :hidden-label="hiddenLabel"
        :for="inputId"
      >
        <slot name="mds-microcopy-above">
          <mds-microcopy
            v-if="microcopyAbove"
            :size="size"
            :on-dark="onDark"
            v-html="microcopyAbove"
          />
        </slot>
        <div :class="['mds-date-picker__wrapper']">
          <div :class="$style['mds-date-picker__icon-wrapper']">
            <input
              autocomplete="off"
              ref="input"
              :class="[
                $style['mds-date-picker__input'],
                inputClassObject,
                inputSizeClass,
              ]"
              :value="formattedDate"
              :required="required"
              :aria-invalid="error"
              v-bind="$attrs"
              aria-autocomplete="none"
              :maxlength="typing ? 7 : 0"
              @input="handleUserInput"
              @keypress="numbersOnly"
              @focus="openDatePicker"
              @click="openDatePicker"
              @keydown.enter.prevent="openDatePicker"
              @keydown="handleTabKey($event)"
              @keyup="handlekeyup($event)"
              placeholder="MM/YYYY"
              @blur="blur($event)"
            />
            <mds-button
              :class="$style['mds-date-picker__clear-button']"
              type="button"
              variation="icon-only"
              :size="iconSize"
              icon="remove"
              :on-dark="onDark"
              @click="clearSelection()"
              v-if="showClearButton"
            ></mds-button>
            <mds-icon
              :class="[
                $style['mds-date-picker__icon'],
                iconClassObject,
                iconSizeClass,
              ]"
              :size="iconSize"
              name="calendar"
              v-if="!showClearButton"
            ></mds-icon>
          </div>
          <transition
            :enter-active-class="
              $style['mds-date-picker__container-enter-active']
            "
            :leave-active-class="
              $style['mds-date-picker__container-leave-active']
            "
            :enter-class="$style['mds-date-picker__container-enter']"
            :leave-to-class="$style['mds-date-picker__container-leave-to']"
          >
            <div
              v-if="showDatePicker"
              :class="[
                $style['mds-date-picker__container'],
                $style['custommonthpicker'],
              ]"
              :id="containerId"
              :aria-hidden="showDatePicker ? 'false' : 'true'"
              ref="popover"
              role="application"
              aria-modal="true"
              v-keyboard-navigation="navigate"
              v-auto-direction="positionResults"
            >
              <mds-list-group :class="$style['custommonthpickerleft']">
                <mds-list-group-item
                  :disabled="true"
                  @click.native="SelectListData(data)"
                  v-for="data in filteredlistdata"
                >
                  <span>
                    <span
                      :class="
                        data.value == selectvalue
                          ? [$style['activemonthpickerlist']]
                          : [$style['deactivemonthpickerlist']]
                      "
                      >{{ data.text }}
                      <span style="opacity: 0.6">{{ data.meta }}</span>
                    </span>

                    <span
                      v-if="data.value == selectvalue"
                      style="position: absolute; right: 4px; top: 6px"
                    >
                      <mds-icon
                        :class="[$style['activelistsvgcard']]"
                        name="check"
                        size="small"
                      ></mds-icon>
                    </span>
                  </span>
                </mds-list-group-item>
              </mds-list-group>
              <div :class="$style['custommonthpickerright']">
                <div :class="$style['mds-date-picker__header']">
                  <div :class="$style['mds-date-picker__header-title']">
                    <mds-button
                      :style="prevButtonclass"
                      tabindex="-1"
                      variation="icon-only"
                      icon="angle-left"
                      type="button"
                      @click="handleButtonClick(PREVIOUS)"
                    ></mds-button>

                    <div
                      style="cursor: pointer"
                      @click.prevent="ShowYearsdata()"
                    >
                      {{ getselectedyear }}
                    </div>

                    <mds-button
                      :style="nextButtonclass"
                      tabindex="-1"
                      variation="icon-only"
                      icon="angle-right"
                      type="button"
                      @click="handleButtonClick(NEXT)"
                    ></mds-button>
                  </div>
                </div>
                <div
                  @click.stop.prevent=""
                  :class="$style['mds-date-picker__calendar']"
                  :id="calendarId"
                  tabindex="-1"
                >
                  <div
                    v-if="!showYears"
                    :class="[
                      $style['mds-date-picker__week'],
                      $style['datepicketitemwrappper'],
                    ]"
                  >
                    <div
                      v-for="d in monthOptions"
                      :key="d.value"
                      :id="d.value"
                      :class="[
                        $style['mds-date-picker__day'],
                        getClassObject(d),
                      ]"
                      role="button"
                      @click.prevent="handleClick(d)"
                    >
                      <span
                        :class="
                          d.value == month
                            ? [$style['activemonthpickerlist']]
                            : []
                        "
                        >{{ d.text }}</span
                      >
                    </div>
                  </div>

                  <div
                    v-if="showYears"
                    :class="[
                      $style['mds-date-picker__week'],
                      $style['datepicketitemwrappper'],
                    ]"
                  >
                    <div
                      v-for="d in years[currentYearGroup]"
                      :key="d.value"
                      :id="d.value"
                      :class="[
                        $style['mds-date-picker__day'],
                        getClassObject(d),
                      ]"
                      role="button"
                      @click.prevent="handleClickyear(d)"
                    >
                      <span>{{ d.text }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
        <div
          v-if="error"
          :class="$style['mds-date-picker__field-error-wrapper']"
          aria-live="assertive"
          role="alert"
        >
          <mds-field-error
            v-for="(text, index) in errorText"
            :key="index"
            v-show="error"
            :size="size"
            v-html="text"
            :on-dark="onDark"
          />
        </div>
        <slot name="mds-microcopy-below">
          <mds-microcopy
            v-if="microcopy"
            :size="size"
            v-html="microcopy"
            :on-dark="onDark"
          />
        </slot>
      </mds-label>
    </div>
  </div>
</template>

<script>
import MdsIcon from "@mds/icon";
import MdsLabel from "@mds/label";
import MdsFieldError from "@mds/field-error";
import MdsMicrocopy from "@mds/microcopy";
import { MdsButton, MdsButtonContainer } from "@mds/button";
import { MDSKeyboardNavigation } from "@mds/utils-js";
import { PREVIOUS, NEXT } from "./date-picker_constants.js";
import DatePickerDirectives from "./date-picker_directives.js";
import { MdsListGroup, MdsListGroupItem } from "@mds/list-group";

export default {
  name: "AdlMonthPickerSelect",
  components: {
    MdsLabel,
    MdsFieldError,
    MdsMicrocopy,
    MdsIcon,
    MdsButton,
    MdsButtonContainer,
    MdsListGroup,
    MdsListGroupItem,
  },
  props: {
    listdata: [],
    displayTop: {
      type: Boolean,
      default: false,
      docs: {
        validation: "—",
        description:
          "If `true`, positions the popover above the date picker input field.",
      },
    },
    isShowFocus: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
      docs: {
        validation: "—",
        description:
          "If `true`, triggers the error state and shows the `errorText` for the input.",
      },
    },
    showLeft: {
      type: Boolean,
      default: true,
    },
    errorText: {
      type: Array,
      docs: {
        validation: "—",
        description:
          "Sets the error text that appears when `error=true` for the input.",
        support: ["v-html"],
      },
    },
    hiddenLabel: {
      type: Boolean,
      default: false,
      docs: {
        validation: "—",
        description: "If `true`, visibly hides the input’s label.",
      },
    },
    label: {
      type: String,
      required: true,
      docs: {
        validation: "**Required**",
        description: "Sets the label for the input.",
      },
    },

    microcopyAbove: {
      type: String,
      docs: {
        validation: "—",
        description: "Sets the microcopy above the input.",
        support: ["v-html"],
      },
    },
    microcopyBelow: {
      type: String,
      docs: {
        validation: "—",
        description: "Sets the microcopy below the input.",
        support: ["v-html"],
      },
    },
    onDark: {
      type: Boolean,
      default: false,
      docs: {
        validation: "—",
        description: "If `true`, changes component to on-dark styling.",
      },
    },
    required: {
      type: Boolean,
      default: false,
      docs: {
        validation: "—",
        description:
          "If `true`, displays the required indicator (*) on the input label.",
      },
    },
    requiredText: {
      type: String,
      default: "This field is required",
      docs: {
        validation: "—",
        description:
          "Sets the `aria-label` text to describe an input as required.",
      },
    },
    size: {
      type: String,
      default: "medium",
      validator(value) {
        return ["small", "medium", "large", "touch"].indexOf(value) !== -1;
      },
      docs: {
        validation: "One of: `small`, `medium`, `large`, `touch`.",
        description: "Sets the size of the input.",
      },
    },
    typing: {
      type: Boolean,
      default: false,
      docs: {
        validation: "—",
        description:
          "If `true`, allows typing in the input. If `false`, only allows the backspace key to clear the value from the input.",
      },
    },
    value: {
      type: [String],
      default: "",
      docs: {
        validation: "—",
        description: "Sets the selected date for the date picker.",
        support: ["v-model"],
      },
    },
    minYear: {
      type: Number,
      required: true,
    },
    yearTerm: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      selectvalue: "",
      year: null,
      month: null,
      selectedDate: "10/2020",
      focusedDate: null,
      focusedDateId: "",
      isopenCalendar: false,
      monthOptions: [],
      showDatePicker: false,
      isCalendarActive: false,
      isMouseOverCalendar: false,
      PREVIOUS,
      NEXT,
      currentYearGroup: 1,
      showYears: false,
      presentYear: new Date().getFullYear(),
      prevButtonclass: "",
      nextButtonClass: "",
      microcopy: "",
    };
  },
  created() {
    // const today = new Date();
    // this.year = today.getFullYear();
    // this.month = today.getMonth() + 1;
    this.microcopy = this.microcopyBelow;
    this.setMonthOptions();
    this.setInitialSelection();
  },

  computed: {
    otherlistdatavalue() {
      return this.listdata.filter((x) => x.meta == "")[0].value;
    },
    filteredlistdata() {
      return this.listdata.filter((x) => x.meta != "");
    },
    otherlistdatatext() {
      return this.listdata.filter((x) => x.meta == "")[0].text;
    },
    getselectedyear() {
      return this.presentYear;
    },
    getmaxYear() {
      return this.minYear + this.yearTerm;
    },
    getmonthheader() {
      if (this.month != null) return this.getMonthName(this.month);
      else return "Month";
    },
    formattedDate() {
      if (this.value != "") {
        if (this.value.hasOwnProperty("meta")) {
          this.selectedDate = this.value.meta;
        } else {
          this.selectedDate = this.value;
        }
        return this.selectedDate;
      } else {
        return this.value;
      }
    },
    inputSizeClass() {
      return this.$style[`mds-date-picker__input--${this.size}`];
    },
    inputClassObject() {
      const obj = {};
      obj[this.$style["mds-date-picker__input--error"]] = this.error;
      obj[this.$style["mds-date-picker__input--on-dark"]] = this.onDark;

      return obj;
    },
    iconSize() {
      return this.size === "small" || this.size === "medium"
        ? "small"
        : "medium";
    },
    iconSizeClass() {
      return this.$style[`mds-date-picker__input-icon--${this.size}`];
    },
    iconClassObject() {
      const obj = {};
      obj[this.$style["mds-date-picker__input-icon--on-dark"]] = this.onDark;

      return obj;
    },
    inputId() {
      return `mds-date-picker-input-${this.getRandomId()}`;
    },
    containerId() {
      return `mds-date-picker-container-${this.getRandomId()}`;
    },
    calendarId() {
      return `mds-date-picker-calendar-${this.getRandomId()}`;
    },

    months() {
      let monthData = [];
      for (let i = 1; i <= 12; i++) monthData.push(i);
      return monthData;
    },
    years() {
      let yearsData = {};
      let x = 1;
      let y = 1;
      for (let i = this.minYear; i <= this.minYear + this.yearTerm; i++) {
        if (x == 13) {
          x = 1;
          y = y + 1;
        }
        if (x == 1) {
          yearsData[y.toString()] = [];
        }
        yearsData[y.toString()].push({
          text: i.toString(),
          value: i,
        });
        x++;
      }

      return yearsData;
    },

    fullDate() {
      return {
        year: this.year,
        month: this.month,
      };
    },
    showClearButton() {
      return this.selectedDate && this.showDatePicker;
    },
  },
  watch: {
    isShowFocus: {
      handler: function (val) {
        if (val) {
          this.$nextTick(() => {
            this.isopenCalendar = true;
            this.$refs["input"].focus();
          });
        }
      },
    },
    value: {
      handler: function (value) {
        if (!value) {
          this.selectvalue = "";
          this.microcopyBelow = "";
          this.microcopyAbove = "";

          this.selectvalue = "";
          this.year = null;
          this.month = null;
          this.microcopy = "";
          this.focusedDate = null;
          this.focusedDateId = "";
          this.presentYear = new Date().getFullYear();
        }
      },
    },
  },
  directives: {
    clickOutside: DatePickerDirectives.clickOutside,
    autoDirection: MDSKeyboardNavigation.autoDirection,
    keyboardNavigation: MDSKeyboardNavigation.keyboardNavigation,
  },
  methods: {
    getMonthfromdate(val) {
      return val.slice(0, val.indexOf("/"));
    },
    getYearFromDate(val) {
      return val.slice(val.indexOf("/") + 1, val.length);
    },
    SelectListData(data) {
      this.selectedDate = data.meta;
      this.hideDatePicker();
      this.microcopy = data.text;
      this.selectvalue = data.value;
      let month = this.getMonthfromdate(data.meta);
      let year = this.getYearFromDate(data.meta);
      this.month = month;
      this.year = year;
      this.presentYear = year;
      this.$emit("input", data);
    },
    iconclass(mode, state) {
      if (mode == PREVIOUS) {
        this.prevButtonclass = state ? "" : "visibility: hidden;";
      } else {
        this.nextButtonClass = state ? "" : "visibility: hidden;";
      }
    },
    ShowYearsdata() {
      this.showYears = !this.showYears;
    },
    convertdate(value) {
      let val = value;
      let yearvalue = "";
      if (val.indexOf("/") > 0) {
        let separaterindex = val.indexOf("/");
        yearvalue = val.slice(separaterindex + 1);
        if (yearvalue.length == 2) {
          let currentyear = new Date().getFullYear().toString();
          let currentyearvalue = currentyear.substring(0, 2);
          yearvalue = currentyearvalue + yearvalue;
        }
        let newDate = val.substring(0, separaterindex) + "/" + yearvalue;
        // this.updateSelection(newDate);

        this.selectedDate = newDate;
        this.$emit("input", this.getEmitModel(newDate));
      }
      return val;
    },
    blur(evt) {
      if (this.listdata.filter((x) => x.meta == evt.target.value).length == 0) {
        evt.target.value = this.convertdate(evt.target.value);
        if (evt.target.value != "") {
          if (
            this.listdata.filter((x) => x.meta == evt.target.value).length == 0
          )
            this.microcopy = this.otherlistdatatext;
          // else
          // this.microcopy=this.listdata.filter(x=>x.meta==evt.target.value)[0].text;
        } else {
          this.clearSelection();
        }
        this.selectvalue = "";
      }
    },
    handlekeyup(evt) {
      const month = evt.target.value.split("/")[0];
      const year = evt.target.value.split("/")[1];
      if (evt.keyCode == "8") return;
      if (month > 12) {
        evt.target.value = "12" + "/" + (year ? year : "");
      }
      if (year > this.getmaxYear) {
        evt.target.value = month + "/" + this.getmaxYear;
      }
      // if (evt.target.value == 0) {
      //   evt.target.value = "01/";
      // }
      if (evt.target.value.indexOf("/") == -1 && evt.target.value.length == 2) {
        evt.target.value = evt.target.value + "/";
      }
    },
    numbersOnly(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        (charCode >= 48 && charCode <= 57) ||
        (charCode >= 96 && charCode <= 105)
      ) {
        return true;
      } else {
        evt.preventDefault();
      }
    },
    handleTabKey(event) {
      if (event.key === "Tab") {
        this.hideDatePicker();
        event.target.value = this.convertdate(event.target.value);
      }
    },
    handleUserInput(e) {
      if (this.typing) {
        // if (e.target.value.toString().length == 2) {
        //   e.target.value = e.target.value + "/";
        // }
        this.$emit("input", this.getEmitModel(e.target.value));
        this.openDatePicker();
      } else {
        e.preventDefault();
      }
    },
    /**
     * input event cannot prevent the delete key behavior so use keydown
     */
    getEmitModel(Date, text = "Other", value = 0) {
      let Data = {
        text: text,
        value: value == 0 ? this.otherlistdatavalue : value,
        meta: Date,
      };
      return Data;
    },
    updateSelection(date) {
      this.selectedDate = date;
      this.$emit("input", this.getEmitModel(date));
      this.hideDatePicker();
    },
    getRandomId() {
      const randomId = Math.random() * Math.floor(1000000);
      return Math.round(randomId);
    },
    getMonthName(monthNumber) {
      const date = new Date();
      date.setDate(1);
      date.setMonth(monthNumber - 1);

      return date.toLocaleString("en-US", {
        month: "short",
      });
    },
    setMonthOptions() {
      let monthOptions = this.months.map((month, index) => ({
        text: this.getMonthName(month),
        value: index + 1,
      }));
      this.monthOptions = monthOptions;
    },

    openDatePicker() {
      this.currentYearGroup = 1;
      this.showYears = false;
      this.showDatePicker = true;
    },
    hideDatePicker() {
      if (!this.isopenCalendar) {
        this.currentYearGroup = 1;

        this.showYears = false;

        this.showDatePicker = false;
      } else {
        this.isopenCalendar = false;
      }
      // if (this.formattedDate != null)
      //   this.convertdate(this.formattedDate);
    },
    positionResults(el) {
      const selectionOffset = this.$refs.maindiv.getBoundingClientRect().height;

      let style = "";

      if (this.displayTop) {
        style = `bottom: ${selectionOffset ? selectionOffset : 0}px;`;
      } else {
        let selectedset = selectionOffset;

        if (this.microcopy != "" && !this.displayTop) {
          selectedset = selectionOffset - 25;
        }

        style = `top: ${selectedset}px;`;
      }

      if (this.showLeft) {
        style += "right:0px";
      }

      el.style.cssText = style;
    },
    setInitialSelection() {
      this.selectedDate = this.value;
    },

    createDate(year, month) {
      return ("0" + month).slice(-2) + "/" + year;
    },

    handleButtonClick(mode) {
      if (mode === PREVIOUS) {
        if (this.showYears) {
          if (this.currentYearGroup > 1) {
            this.currentYearGroup = parseInt(this.currentYearGroup) - 1;
          }
        } else {
          if (this.presentYear >= this.minYear) {
            this.presentYear = parseInt(this.presentYear) - 1;
            this.iconclass(PREVIOUS, true);
            this.iconclass(NEXT, true);
          }
          if (this.presentYear == this.minYear) {
            this.iconclass(PREVIOUS, false);
          }
        }
      } else {
        if (this.showYears) {
          if (this.currentYearGroup < Object.keys(this.years).length)
            this.currentYearGroup = parseInt(this.currentYearGroup) + 1;
        } else {
          if (this.presentYear <= this.minYear + this.yearTerm) {
            this.presentYear = parseInt(this.presentYear) + 1;
            this.iconclass(NEXT, true);
            this.iconclass(PREVIOUS, true);
          }
          if (this.presentYear == this.minYear + this.yearTerm) {
            this.iconclass(NEXT, false);
          }
        }
      }
    },

    navigate(event) {
      if (event.key === "Escape" || event.key === "Esc") {
        this.hideDatePicker();
      }
    },

    handleClick(d) {
      this.month = d.value;
      const newDate = this.createDate(this.presentYear, this.month);
      this.updateSelection(newDate);
      this.microcopy = this.otherlistdatatext;
      this.selectvalue = "";
    },
    handleClickyear(d) {
      this.month = null;
      this.presentYear = d.value;
      this.year = d.value;
      this.showYears = false;
      // const newDate = this.createDate(d.value, this.month);
      // this.updateSelection(newDate);
    },
    updateFocus(date) {
      this.focusedDate = date;
    },
    clearSelection() {
      this.selectedDate = "";
      this.year = null;
      this.month = null;
      this.microcopy = "";
      this.selectvalue = "";
      this.$emit("input", "");
    },
    getClassObject(d) {
      const obj = {};
      obj[this.$style["mds-date-picker__day"]] = true;
      obj[this.$style["mds-date-picker__day--today"]] =
        this.highlightToday && d.isToday;
      obj[this.$style["mds-date-picker__day--not-in-month"]] =
        !d.isCurrentMonth;
      obj[this.$style["mds-date-picker__day--selected"]] =
        !d.isDisabled && d.isSelected;
      obj[this.$style["mds-date-picker__day--disabled"]] = d.isDisabled;
      obj[this.$style["mds-date-picker__day--focused"]] =
        !d.isSelected && d.isFocused && this.isCalendarActive;
      return obj;
    },
  },
};
</script>

<style lang="scss" module>
@import "./date-picker.scss";

.activemonthpickerlist {
  color: #0077cf !important;
}

.deactivemonthpickerlist {
  color: #1e1e1e !important;
}

.activelistsvgcard {
  stroke: #0077cf !important;
  fill: #0077cf !important;
}

.mds-date-picker__header-title {
  flex-grow: 1;
  justify-content: space-between;
}

.custommonthpicker {
  flex-direction: row !important;
  display: flex !important;
  width: 450px;
  padding: 0px !important;

  ul {
    li {
      &.mds-list-group-item--disabled {
        cursor: pointer !important;

        .mds-list-group__link {
          cursor: pointer !important;
          opacity: 1 !important;
          pointer-events: auto !important;
        }
      }
    }
  }

  // width: 250px;
  .custommonthpickerleft {
    padding: 8px;
    border-right: 1px solid #ddd;
    width: 100%;
  }

  .custommonthpickerright {
    padding: 8px;
    width: 100%;
  }

  .datepicketitemwrappper {
    flex-wrap: wrap;
    justify-content: stretch !important;

    div {
      width: 25% !important;
      box-sizing: border-box;
    }
  }
}
</style>
